// ============================================================
// useHomework Hook
// ============================================================

import { useEffect } from 'react';
import useTeacherStore from '@/store/teacherStore';
import teacherService from '@/services/teacherService';
import { useSchool } from './useSchool';
import { useAuth } from './useAuth';

export function useHomework() {
  const { schoolId } = useSchool();
  const { user } = useAuth();
  const teacherId = user?.teacherId;
  
  const homework = useTeacherStore((s) => s.homework);
  const loading = useTeacherStore((s) => s.loading);
  const error = useTeacherStore((s) => s.error);
  const fetchTeacherHomework = useTeacherStore((s) => s.fetchTeacherHomework);

  useEffect(() => {
    if (schoolId && teacherId) {
      fetchTeacherHomework(schoolId, teacherId);
    }
  }, [schoolId, teacherId, fetchTeacherHomework]);
  
  const createHomework = async (data) => {
    return teacherService.createHomework(schoolId, teacherId, data).then((res) => {
      fetchTeacherHomework(schoolId, teacherId); // refresh
      return res;
    });
  };
  
  const deleteHomework = async (homeworkId) => {
    return teacherService.deleteHomework(schoolId, homeworkId).then((res) => {
      fetchTeacherHomework(schoolId, teacherId); // refresh
      return res;
    });
  };

  return { 
    homework, 
    loading, 
    error, 
    createHomework,
    deleteHomework,
    refetch: () => fetchTeacherHomework(schoolId, teacherId) 
  };
}
